import React from 'react';
import { Box } from '@mui/material';
import InstitutionBrandRow from './InstitutionBrandRow';

/** Compact institution line for landing/overview pages — primary accent + divider aligned with theme. */
const InstitutionPageHeader = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'stretch',
      gap: 1.5,
      mb: 2.5,
      pb: 2,
      borderBottom: 1,
      borderColor: 'divider',
    }}
  >
    <Box
      aria-hidden
      sx={{
        width: 3,
        flexShrink: 0,
        borderRadius: 1,
        bgcolor: 'primary.main',
        alignSelf: 'stretch',
        minHeight: 28,
      }}
    />
    <Box sx={{ minWidth: 0, flex: 1, display: 'flex', alignItems: 'center' }}>
      <InstitutionBrandRow size="sm" variant="subtitle1" />
    </Box>
  </Box>
);

export default InstitutionPageHeader;
